import {memo} from 'react';
import {number, bool} from 'prop-types';
import {styled, keyframes} from 'styled-components';
import {forbidExtraProps} from 'airbnb-prop-types';
import logoSvg from './Logo.svg';
import progressSvg from './Progress.svg';
import gradientIcon from './Gradient.svg';

const spinnerAnimation = keyframes`
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  position: relative;
  background-image: url("${props => props.$progress ? progressSvg : logoSvg}");
  background-size: cover;
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-image: url("${props => !props.$progress && gradientIcon}");
    animation: ${spinnerAnimation} 1.2s linear infinite;
  }
`;


export default memo(SpinnerSan);

SpinnerSan.propTypes = forbidExtraProps({
  progress: bool,
  size: number.isRequired,
});

function SpinnerSan({
  progress,
  size,
}) {
  return (
    <Spinner $progress={progress} $size={size}/>
  );
}
